// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LoginOutlinedSvg from "@ant-design/icons-svg/es/asn/LoginOutlined";
import AntdIcon from '../components/AntdIcon';

var LoginOutlined = function LoginOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LoginOutlinedSvg
  }));
};

LoginOutlined.displayName = 'LoginOutlined';
export default React.forwardRef(LoginOutlined);